(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('parameters.matiere', {
            parent: 'parameters',
            url: '/matieres',
            title: 'Matières',
            sidebarMeta: {
                icon: 'glyphicon glyphicon-tower',
                order: 7
            },
            data: {
                authorities: ['ROLE_ADMIN','ROLE_RESPONSABLE'],
                pageTitle: 'josdaviApp.matiere.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/matiere/matieres.html',
                    controller: 'MatiereController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('matiere');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });    }

})();
